<template>
  <div class="">
    <div class="relative">
      <div class="absolute bg-design-mbr-dots mob-hidden">
        <img
          src="../../../assets/images/caregiver/mbr-dots.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <!-- <div class="absolute h-full lg:hidden md:hidden block -mt-40px">
        <img
          src="../../../assets/images/line/hcp-line-2.svg"
          alt="bg"
          class="object-cover"
        />
      </div> -->
    </div>

    <div class="md:mb-12 lg:mb-12 md:relative lg:relative">
      <div class="absolute bottom-16 right-0 mob-hidden">
        <img
          src="../../../assets/images/bg-des/hcp-partners-bgt.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div
        class="w-full bgcceff2-res md:py-12 lg:py-12 py-6 md:px-8 lg:px-28 flex-wrap flex flexcolreverse"
      >
        <div
          class="md:w-1/2 lg:w-1/2 w-full lg:px-6 md:pt-0 lg:pt-0 pt-8 z-10 res-bg-white"
        >
          <div class="w-full lg:px-0 md:px-0 px-6">
            <div class="flex w-full py-6 items-center">
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/Accenture-logo.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/aditya birla.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/UBS-logo.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
            </div>
            <div class="flex w-full py-6 items-center">
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/Adobe-logo.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/cr3.png"
                  alt="Partners"
                  class="prt-img-ht2"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/Ford.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
            </div>
            <div class="flex w-full py-6 items-center">
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/Googlelogo.png"
                  alt="Partners"
                  class="prt-img-ht3"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/inharmony.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/full1.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
            </div>
            <div class="flex w-full py-6 items-center">
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/UBS-logo.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/Unilever.png"
                  alt="Partners"
                  class="prt-img-ht4 lg:pl-0 ml-4"
                />
              </div>
            </div>
          </div>
          <div class="w-full mob-hidden hidden">
            <div class="flex w-full py-6 items-center">
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/Accenture-logo.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-2/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/aditya birla.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
            </div>
            <div class="flex w-full py-6 items-center">
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/Adobe-logo.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/cr3.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/corporate-log/Ford.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="md:w-1/2 lg:w-1/2 w-full px-4 lg:pt-0 md:pt-0 pt-4">
          <div class="relative">
            <p class="title sm-fsize16 lg:font-medium md:font-medium font-bold">
              Corporate Partners
            </p>
            <p
              class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-fsize13 sm-lh28"
            >
              Our corporate partnerships are a joint effort to build progressive
              organizations that value employee well-being. We ensure companies
              meet their business objective keeping employee benefits in mind
              which in return helps to build employee morale and boosts overall
              growth.
            </p>
            <!-- <p class="subtitle pt-8 lh32px font-normal letter-spacing-2px">
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est laborum. Excepteur sint
              occaecat cupidatat non proident, sunt in culpa qui officia
              deserunt mollit anim id est laborum.
            </p> -->
          </div>
          <div class="md:pt-10 lg:pt-10 pt-6">
            <a
              class="hover:text-white"
              target="_blank
              "
              href="https://forms.office.com/r/RdZbdsmH6i"
            >
              <base-button
                outline
                type="primary"
                class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2 fsize16-14"
                >Partner with us</base-button
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
